<template>
  <div class="reports-menu">
    <!-- Trigger (inside header) -->
    <div class="menu-trigger" @click="toggleMenu">
      <img
        :src="require('../assets/viaerpwhite.png')"
        alt="Menu"
        class="menu-logo"
      />
    </div>

    <!-- Side Menu -->
    <transition name="slide">
      <div v-if="isOpen" class="menu-panel">
        <ul class="menu-list">
          <li v-if="hasPermission(1)" @click="handleMainPage">
             <span>Main Page</span>
          </li>

          <li v-if="hasPermission(20)" @click="handleAddCustomer">
             <span>Customers</span>
          </li>

          <li v-if="hasPermission(26)" @click="handleFindInvoice">
             <span>Find Invoice</span>
          </li>

          <li v-if="hasPermission(31)" @click="handleProductReturn">
             <span>Return Invoice</span>
          </li>

          <li v-if="hasPermission(33)" @click="handleDailyTotals">
             <span>Daily Totals</span>
          </li>

          <li v-if="hasPermission(34)" @click="handleItemsDaily">
             <span>Department Wise</span>
          </li>

          <li v-if="hasPermission(55)" @click="handleDepItemsDaily">
             <span>Department Items</span>
          </li>

          <li v-if="hasPermission(35)" @click="handleDailySales">
            <span>Daily Sales</span>
          </li>

          <li v-if="hasPermission(36)" @click="handleCashierInvoices">
             <span>Cashier Invoices</span>
          </li>

          <li v-if="hasPermission(37)" @click="handleCashierCash">
              <span>Cashier Cash</span>
          </li>

          <li
            v-if="hasPermission(13)"
            class="logout"
            @click="handleLogout"
          >
             <span>Logout</span>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
import commonServices from "@/shared/commonServices";

export default {
  name: "ReportsMunu",
  mixins: [commonServices],
  data() {
    return {
      jsonData: {},
      reports_ok: "0",
      isOpen: false,
    };
  },
  mounted() {
    this.language = "ar";
    this.handleLanguage();
    if (localStorage.reports_ok === "1") {
      this.reports_ok = true;
    }
  },
  methods: {
    toggleMenu() {
      this.isOpen = !this.isOpen;
    },
    handleMainPage() {
      this.isOpen = false;
      this.$router.push({ name: "main" });
    },
    handleCashierInvoices() {
      this.isOpen = false;
      this.$router.push({ name: "cashierinvoices" });
    },
    handleCashierPayments() {
      this.isOpen = false;
      this.$router.push({ name: "cashierpayments" });
    },
    handleCashierCash() {
      this.isOpen = false;
      this.$router.push({ name: "cashiercash" });
    },
    handleDailyTotals() {
      this.isOpen = false;
      this.$router.push({ name: "dailytotal" });
    },
    handleDailySales() {
      this.isOpen = false;
      this.$router.push({ name: "dailysales" });
    },
    handleItemsDaily() {
      this.isOpen = false;
      this.$router.push({ name: "itemsdaily" });
    },
    handleAllItemsDaily() {
      this.isOpen = false;
      this.$router.push({ name: "allItems" });
    },
    handleDepItemsDaily() {
      this.isOpen = false;
      this.$router.push({ name: "itemsdepdaily" });
    },
    handleAddCustomer() {
      this.isOpen = false;
      this.$router.push({ name: "customers" });
    },
    handleReturns() {
      this.isOpen = false;
      this.$router.push({ name: "returns" });
    },
    handleFindInvoice() {
      this.isOpen = false;
      this.$router.push({ name: "find" });
    },
    goLogin() {
      this.isOpen = false;
      this.$router.push({ name: "login" });
    },
  },
};
</script>

<style scoped>
.reports-menu {
  position: relative;
}

/* Trigger */
.menu-logo {
  width: 55px;
  height: 55px;
  cursor: pointer;
}

/* Menu Panel */
.menu-panel {
  position: absolute;
  top: 70px;
  left: -20px;
  width: 260px;
  background: linear-gradient(180deg, var(--theme-bg-start), var(--theme-bg-end));
  border-radius: 14px;
  padding: 10px;
  box-shadow: 0 10px 30px #00000066;
  z-index: 19990;
}

/* Menu Items */
.menu-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.menu-list li {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px;
  border-radius: 10px;
  color: #f1f1f1;
  cursor: pointer;
  transition: all 0.25s ease;
}

.menu-list li:hover {
  background-color: #3b3b3b;
  transform: translateX(5px);
}

.logout {
  background-color: #c0392b;
}

.logout:hover {
  background-color: #e74c3c;
}

/* Animation */
.slide-enter-active,
.slide-leave-active {
  transition: all 0.25s ease;
}

.slide-enter-from {
  opacity: 0;
  transform: translateX(-15px);
}

.slide-leave-to {
  opacity: 0;
  transform: translateX(-15px);
}
</style>
